import { Button, DialogContent, DialogFooter, DialogHeader, DialogRoot, DialogTitle, Input, Switch } from '@ibsys/kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsBetaFeatureEnabled } from '@/entities/beta-feature';
import type { ExpertReportModelMode } from '@/entities/expert-report';

type CreateReportDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string, modelMode: ExpertReportModelMode) => void;
  isPending: boolean;
};

export const CreateReportDialog: FC<CreateReportDialogProps> = ({ isOpen, onClose, onSubmit, isPending }) => {
  const { t } = useTranslation(['common', 'expertReport']);
  // Режим модели знаний предлагается только при включённой бета-функции
  const isKmModeAvailable = useIsBetaFeatureEnabled('EXPERT_REPORT_KNOWLEDGE_MODEL');
  const [name, setName] = useState('');
  const [isKmMode, setIsKmMode] = useState(false);

  const handleSubmit = () => {
    const trimmedName = name.trim();
    if (!trimmedName) return;
    onSubmit(trimmedName, isKmMode && isKmModeAvailable ? 'km' : 'legacy');
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setName('');
      setIsKmMode(false);
      onClose();
    }
  };

  return (
    <DialogRoot open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('expertReport:createReport')}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-4">
          <Input
            label={t('expertReport:reportName')}
            placeholder={t('expertReport:enterName')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />

          {isKmModeAvailable && (
            <Switch value={isKmMode} onChange={setIsKmMode} label={t('expertReport:km.modeSwitch')} />
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isPending}>
            {t('common:cancel')}
          </Button>
          <Button onClick={handleSubmit} disabled={isPending || !name.trim()}>
            {t('common:add')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
